import createIcon from '@/lib/create-icon'

const PigIcon = createIcon(
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M7.99996 16.1737C6.98663 16.1737 6.16663 15.318 6.16663 14.2606V11.5615C6.16663 10.5041 6.98663 9.64844 7.99996 9.64844C9.01329 9.64844 9.83329 10.5041 9.83329 11.5615V14.2606C9.83329 15.318 9.01329 16.1737 7.99996 16.1737ZM14.1666 14.2606C14.1666 15.318 14.9866 16.1737 16 16.1737C17.0133 16.1737 17.8333 15.318 17.8333 14.2606V11.5615C17.8333 10.5041 17.0133 9.64844 16 9.64844C14.9866 9.64844 14.1666 10.5041 14.1666 11.5615V14.2606Z'
      fill='currentColor'
    />
    <path
      d='M2 13.5833C2.08 7.83583 6.596 4 12 4C17.4047 4 21.92 7.83583 22 13.5833V13.7384C22.0003 14.5607 21.8453 15.375 21.5438 16.1348C21.2424 16.8946 20.8005 17.5849 20.2433 18.1664C19.6861 18.7479 19.0245 19.2091 18.2965 19.5237C17.5684 19.8383 16.788 20.0002 16 20H8C4.68533 20 2 17.1979 2 13.7391V13.5882V13.5833ZM3.33333 13.5979V13.7391C3.33333 16.4292 5.42133 18.6087 8 18.6087H16C18.5787 18.6087 20.6667 16.4299 20.6667 13.7391V13.5986C20.5967 8.74713 16.8073 5.3913 12 5.3913C7.19267 5.3913 3.40267 8.74644 3.33333 13.5979Z'
      fill='currentColor'
    />
  </svg>,
  'PigIcon'
)

export default PigIcon
